import { Provider } from '@angular/core';
import { FormGridInstanceStore } from './services/form-grid-instance.store';
import { FormGridModeService } from './services/form-grid-mode.service';
import { FormGridService } from './services/form-grid.service';
import { FormGridVisibilityService } from './services/form-grid-visibility.service';

export const provideFormGrid = (): Provider[] => [
  FormGridInstanceStore,
  FormGridModeService,
  FormGridVisibilityService,
  FormGridService,
];
